/**
 * Configuração do ambiente de staging no srv01.
 */
export const environment = {
  production: true,
  baseUrl: 'https://api.staging.mrdoctor.com.br',
  metaEmbeddedSignup: {
    appId: '822989857037027',
    configurationId: '1463970522011381'
  }
};
